import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import errorLogger from 'Root/errorLogger'
import { Link } from 'react-router'
import * as R from 'ramda'
import {
  _FilterBarFlex,
  _IconContainer,
  _Divider,
  _ShowMore,
} from './styles'

export const getTagElems = tagFilters => {
  if(!tagFilters || !tagFilters.length) return null
  return tagFilters.map((filter) => (
    <div data-test-id={'filterBarTag'} key={filter}>
      {/* eslint-disable-next-line */}
      <div dangerouslySetInnerHTML={{ __html: filter }} />
    </div>
  ))
}
const dividerElem = <_Divider className={'filterBarDivider'}>|</_Divider>
const FilterBar = ({ filterStrings, filterList, onEditClick, url, tags, isReComputingTags }) => {
  const IconWrapper = url ? Link : 'div'
  let filters = null
  let tagFilters = ''

  if(filterStrings) {
    filters = getTagElems(R.values(filterStrings))
  } else if(filterList) {
    filters = getTagElems(filterList)
  }
  if(tags) {
    try {
      tagFilters = getTagElems(JSON.parse(tags))
    } catch(e) {
      errorLogger('FilterBar parse JSON', e)
      return null
    }
  }
  return (
    <_FilterBarFlex align={'center'}>
      <IconWrapper
        data-test-id={'FilterBarIconWrapper'}
        to={url}
        onClick={onEditClick}
        aria-label="filter to city"
      >
        <_IconContainer>
          <SvgIcon name={'#icon-edit-material'} width={16} height={16} />
        </_IconContainer>
      </IconWrapper>
      {isReComputingTags ? (
        <div data-test-id={'reComputing'}>
          loading tags...
        </div>
      ) : (
        <_ShowMore
          btnClass=""
          disableShowLess
          showCount
          elements={filters || tagFilters}
          minShow={4}
          buttonText={'More Filters'}
          dividerElem={dividerElem}
        />
      )}

    </_FilterBarFlex>
  )
}
FilterBar.propTypes = {
  url: PropTypes.string,
  tags: PropTypes.string,
  isReComputingTags: PropTypes.bool,
  onEditClick: PropTypes.func,
  filterList: PropTypes.arrayOf(PropTypes.string),
  filterStrings: PropTypes.shape({}),
}
export default FilterBar
